<template>
  <div id="container">
    <div id="left" class="column"></div>
    <div id="center" class="columns">
      <div style="padding: 20px; text-align: center" v-if="btnShow">
        <el-button @click="onClickDownload" type="primary">下载PDF</el-button>
      </div>
      <div id="pdfDom">
        <!-- 首页 -->
        <div class="banner">
          <div class="tui-reportHeader">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-23/20220623135937_1734.png?x-oss-process=style/imgset"
              style="width: 10rem; height: 100%"
              alt=""
              crossOrigin="anonymous"
            />
            <div
              style="
                position: absolute;
                top: -15px;
                left: 0;
                right: 0;
                text-align: center;
              "
            >
              <div class="TenanName">{{ userInfo.SchoolName }}</div>
              <div class="tui-reportTitle">
                {{ dataInfo.StudentName }}评估分析报告
              </div>
            </div>
          </div>
          <div class="tui-bottomDesc">
            {{ dataInfo.CycleName }} {{ dataInfo.ClassName }}
          </div>
          <!-- <div class="header-all-title">
            <div class="tui-headerTitle" style="">
              {{ userInfo.SchoolName }}
            </div>
            <div class="tui-headerName">
              {{ dataInfo.StudentName }}评估分析报告
            </div>

            <div
              style="
                font-size: 25px;
                font-weight: bold;
                color: #333;
                padding-top: 160px;
              "
            >
              {{ dataInfo.CycleName }} {{ dataInfo.ClassName }}
            </div>
          </div> -->
        </div>
        <!-- 评价说明 -->
        <div
          class="explain"
          style="height: 1097px; padding: 20px 40px 20px 40px"
        >
          <h3 style="display: flex">
            <span class="w_icon"></span>
            <span style="color: #000; font-size: 18px; padding-left: 10px"
              >评价指南说明</span
            >
          </h3>
          <p>
            一、为深入贯彻《国家中长期教育改革和发展规划纲要（2010—2020年）》和《国务院关于当前发展学前教育的若干意见》（国发〔2010〕41号），指导幼儿园和家庭实施科学的保育和教育，促进幼儿身心全面和谐，制定《3~6岁儿童学习与发展指南》（以下简称《指南》）。
          </p>
          <p>
            二、《指南》以为幼儿后继学习和终身发展奠定良好素质基础为目标，以促进幼儿体、智、德、美各方面的协调发展为核心，通过提出3~6岁各年龄段儿童学习与发展目标和相应的教育建议，帮助幼儿园教师和家长了解3~6岁幼儿学习与发展的基本规律和特点，建立对幼儿发展的合理期望，实施科学的保育和教育，让幼儿度过快乐而有意义的童年。
          </p>
          <p>
            三、《指南》从健康、语言、社会、科学、艺术五个领域描述幼儿的学习与发展。每个领域按照幼儿学习与发展最基本、最重要的内容划分为若干方面。每个方面由学习与发展目标和教育建议两部分组成。目标部分分别对3~4岁、4~5岁、5~6岁三个年龄段末期幼儿应该知道什么、能做什么，大致可以达到什么发展水平提出了合理期望，指明了幼儿学习与发展的具体方向；教育建议部分列举了一些能够有效帮助和促进幼儿学习与发展的教育途径与方法。
          </p>
          <p>
            四、实施《指南》应把握以下几个方面∶
            <br />
            1.关注幼儿学习与发展的整体性。儿童的发展是一个整体，要注重领域之间、目标之间的相互渗透和整合，促进幼儿身心全面协调发展，而不应片面追求某一方面或几方面的发展。
            <br />2.尊重幼儿发展的个体差异。幼儿的发展是一个持续、渐进的过程，同时也表现出一定的阶段性特征。每个幼儿在沿着相似进程发展的过程中，各自的发展速度和到达某一水平的时间不完全相同。要充分理解和尊重幼儿发进程中的个别差异，支持和引导他们从原有水平向更高水平发展，按照自身的速度和方式到达《指南》所呈现的受展"阶梯"，切忌用一把"尺子"衡量所有幼儿。
            <br />3.理解幼儿的学习方式和特点。幼儿的学习是以直接经验为基础，在游戏和日常生活中进行的。要珍视游戏和生活的独特价值，创设丰富的教育环境，合理安排一日生活，最大限度地支持和满足幼儿通过直接感知、实际操作和亲身体验获取经验的需要，严禁"拔苗助长"式的超前教育和强化训练。
            <br />4.重视幼儿的学习品质。幼儿在活动过程中表现出的积极态度和良好行为倾向是终身学习与发展所必需的宝贵品质。要充分尊重和保护幼儿的好奇心和学习兴趣帮助幼儿逐步养成积极主动、认真专注、不怕困难、敢于探究和尝试、乐于想象和创造等良好学习品质。忽视幼儿学习品质培养，单纯追求知识技能学习的做法是短视而有害的。
          </p>
          <p>
            五、“3-6岁儿童发展行为观察指引”包括健康与体能、习惯与自理、自我与社会性、语言与交流、探究与认知、美感与表现6个领域，14个子领域，并各自列出观察内容及不同阶段的行为表现。它适用于了解、分析上海地区全体3-6岁幼儿的发展状况。
            “3-6岁儿童发展行为观察指引”通过“表现行为”来呈现幼儿不同阶段的发展状态。当幼儿已经稳定达到“表现行为1”却与“表现行为3”尚有差距时，其处于“表现行为2”阶段;同理,已稳定达成“表现行为3”，却未达“表现行为5”,其处于“表现行为4”阶段。值得提出的是,所列出的表现行为，并不完全对应幼儿的3-4岁、4-5岁、5-6岁年龄段，而只是列出了幼儿发展的阶段性典型表现行为。幼儿园和教师要认识并尊重幼儿各方面发展存在的不均衡性和个体差异性，切忌将表现行为当成是三个年龄段幼儿的发展水平。幼儿在稳定达到某一阶段时，教师可以运用后一阶段的表现行为作为观察和了解幼儿的参照，并提供适宜的活动机会,引导幼儿向后一阶段发展。
          </p>
        </div>
        <!-- 指标结构 -->
        <div class="construction" style="padding: 30px 40px 0px 40px">
          <h3 style="display: flex">
            <span class="w_icon"></span>
            <span style="color: #000; font-size: 18px; padding-left: 10px"
              >指标结构</span
            >
          </h3>
          <div
            v-if="tables.length == 6"
            style="height: 350px; width: 692px; margin: 0 auto"
          >
            <img
              v-if="Sex == '女'"
              style="width: 692px; height: auto"
              src="../../assets/construction.png"
              alt=""
            />
            <img
              v-if="Sex == '男'"
              style="width: 692px; height: auto"
              src="../../assets/construction_boby.png"
              alt=""
            />
          </div>
          <div
            v-if="tables.length == 5"
            style="height: 350px; width: 692px; margin: 0 auto"
          >
            <img
              v-if="Sex == '女'"
              style="width: 692px; height: auto"
              src="../../assets/five_bg_boby.png"
              alt=""
            />
            <img
              v-if="Sex == '男'"
              style="width: 692px; height: auto"
              src="../../assets/five_bg_girl.png"
              alt=""
            />
          </div>
        </div>
        <div class="layui-tab-item layui-show">
          <div
            class="table_box"
            :id="'table_boxCate' + ind"
            style="padding: 0px 40px 0px 40px"
            v-for="(typeListvalue, ind) in tables"
            :key="ind"
          >
            <div v-if="typeListvalue.table.length != 0">
              <div :id="'biaoge' + typeListvalue._id" class="title_icon">
                <span class="w_icon"></span>
                <span class="title">{{ typeListvalue.Name }}</span>
              </div>
              <div class="indicator">
                <div v-for="(color, index) in SelfList" :key="index">
                  <span :style="{ background: color.color }"></span>
                  <span>{{ color.title }}</span>
                </div>
              </div>

              <template v-if="typeListvalue.table.length != 0">
                <!-- 表格 -->
                <div
                  class="table_2"
                  :id="typeListvalue.Name"
                  v-for="(item, index) in typeListvalue.table"
                  :key="index"
                >
                  <div class="table_title" :id="'table' + item._id">
                    {{ item.CategoryName }}
                  </div>
                  <div class="table_2_box">
                    <div class="table">
                      <div
                        class="table_ans"
                        v-for="(items, indexs) in item.data"
                        :key="indexs"
                        @click="
                          LookActives(items.Color, items.InterveneContent)
                        "
                      >
                        <div
                          :class="[
                            'table_ans_list',
                            items.Iscolor ? 'twoList' : '',
                          ]"
                        >
                          {{ items.title }}
                        </div>

                        <div class="table_ans_list" v-if="items.Iscolor">
                          <div
                            class="icon_circle"
                            :style="{ background: items.Color }"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 标题 -->
                <div class="title_icon" :id="'zuozheng' + typeListvalue._id">
                  <span class="w_icon"></span>
                  <span class="title">{{ typeListvalue.Name }}</span>
                </div>
                <!-- 图片列表 -->
                <div
                  class="flex_imgbox"
                  :id="'flex_imgbox' + typeListvalue._id"
                >
                  <div
                    class="imgs_src"
                    v-for="itemImage in typeListvalue.ListImg"
                    :key="itemImage"
                  >
                    <img
                      :src="itemImage + '?x-oss-process=style/imgset'"
                      crossOrigin="anonymous"
                      alt=""
                    />
                  </div>
                  <div
                    class="imgs_src"
                    v-if="typeListvalue.ListImg.length == 0"
                  >
                    <img
                      style="width: 160px"
                      src="../../assets/no-data.png"
                      crossOrigin="anonymous"
                      alt=""
                    />
                  </div>
                </div>
                <!-- 数据对比 -->
                <div class="layui-tab layui-tab-brief main_tab">
                  <div
                    :id="'chart_title' + typeListvalue._id"
                    class="chart_title"
                    style="
                      font-size: 18px;
                      font-family: PingFang SC;
                      color: #3f96ff;
                      text-align: center;
                    "
                  >
                    {{ typeListvalue.Name }}评价对比
                  </div>
                  <div class="layui-tab-content">
                    <div
                      :id="'echartsAll' + typeListvalue._id"
                      style="width: 600px; height: 300px; margin: 0 auto"
                      v-show="
                        typeListvalue.Series && typeListvalue.Series.length != 0
                      "
                    ></div>
                    <div
                      style="width: 600px; height: 300px"
                      v-show="
                        !(
                          typeListvalue.Series &&
                          typeListvalue.Series.length != 0
                        )
                      "
                      class="NoCover"
                    >
                      <img
                        src="../../assets/no-data.png"
                        crossOrigin="anonymous"
                        style="width: 240px; height: auto"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div style="padding: 20px 20px 0 20px">
          <div
            style="
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <h3 style="display: flex">
              <span class="w_icon"></span>
              <span style="color: #000; font-size: 18px; padding-left: 10px"
                >老师寄语</span
              >
            </h3>
            <div
              style="
                font-size: 28px;
                color: #4cbff4;
                width: 96px;
                height: 40px;
                text-align: center;
                border-radius: 8px;
              "
            ></div>
          </div>
          <div style="font-size: 16px" class="GrowthMessage">
            {{ GrowthMessage ? GrowthMessage : "教师未填写" }}
          </div>
        </div>
        <div style="margin: 0 auto; height: 1137px; text-align: center">
          <img
            src="../../assets/fengdi-f1.png"
            style="width: 100%; height: auto"
            alt=""
          />
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div id="right" class="column"></div>
    <el-dialog title="教育建议" :visible.sync="dialogVisible" width="30%">
      <span style="font-size: 16px">{{ Active }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { FrontTermReportDetailInfo } from "../../api/api";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  data() {
    return {
      dialogVisible: false,
      tables: [],
      Sex: "女",
      Active: "",
      btnShow: false,
      userInfo: {},
      SelfList: [],
      GrowthMessage: "",
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    this.dataInfo = JSON.parse(unescape(this.$route.query.dataInfo));
    if (!this.dataInfo.IsBaby) {
      //   和后端数据相对应的不要修改
      this.SelfList = [
        {
          title: "加油",
          color: "#F44C4C",
        },
        {
          title: "突出",
          color: "#3F96FF",
        },
        {
          title: "真棒",
          color: "#0CBF10",
        },
      ];
    } else {
      this.SelfList = [
        {
          title: "加油",
          color: "#F44C4C",
        },
        {
          title: "突出",
          color: "#3F96FF",
        },
      ];
    }
  },
  mounted() {
    this.FrontTermReportDetailInfo();
  },
  methods: {
    async FrontTermReportDetailInfo() {
      let xhr = await FrontTermReportDetailInfo({
        CycleId: this.dataInfo.CycleId,
        GradeId: this.dataInfo.GradeId,
        StudentId: this.dataInfo.StudentId,
        IsBaby: this.dataInfo.IsBaby,
        BabyLevel: this.dataInfo.BabyLevel,
      });
      if (xhr.data.success) {
        xhr.data.response.list.forEach((element, index) => {
          // 添加唯一的_id
          element._id = index;
          element.table.forEach((itemTwo, indexTwo) => {
            itemTwo._id = `${index}_${indexTwo}`;
            itemTwo.data.forEach((itemThere, indexThere) => {
              itemThere._id = `${index}_${indexTwo}_${indexThere}`;
            });
          });
          //   处理图片
          if (element.ListImg) {
            let arr = element.ListImg.split(",");
            element.ListImg = arr.filter((item) => {
              return item;
            });
          } else {
            element.ListImg = [];
          }
        });
        this.tables = xhr.data.response.list;

        // 处理老师的话
        if (xhr.data.response.TeacherMessage) {
          if (xhr.data.response.TeacherMessage.length > 390) {
            this.GrowthMessage =
              xhr.data.response.TeacherMessage.substring(0, 390) + "...";
          } else {
            this.GrowthMessage = xhr.data.response.TeacherMessage;
          }
        }
        // 处理canvas数据
        setTimeout(() => {
          this.btnShow = true;
          for (let ind = 0; ind < this.tables.length; ind++) {
            let item = this.tables[ind];
            let echarts = document.getElementById("echartsAll" + item._id);
            let myChart;
            if (echarts) {
              myChart = this.$echarts.init(echarts);
            }
            let option = {
              color: ["#7AC064", "#DF7C4B", "#438ACA"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                data: item.Legend_data,
              },
              xAxis: [
                {
                  axisLabel: {
                    align: "center",
                    interval: 0,
                    width: 30,
                  },
                  type: "category",
                  data: item.Xaxis_data,
                  axisPointer: {
                    type: "shadow",
                  },
                },
              ],
              yAxis: [
                {
                  axisTick: {
                    show: false, //不显示坐标轴刻度线
                  },
                  axisLine: {
                    show: false, //不显示坐标轴线
                  },
                  type: "value",
                  // name: "Precipitation",
                  min: 0,
                  max: 12,
                  interval: 1,
                  // axisLabel: {
                  //   formatter: "{value} ml",
                  // },
                },
              ],
              series: item.Series,
            };
            myChart.setOption(option, true);
            window.addEventListener("resize", () => {
              myChart.resize();
            });
          }
        }, 500);
      }
    },

    // 下载PDF
    onClickDownload() {
      this.btnShow = false;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        // var Name = this.$route.query.Name + this.$route.query.CycleName;
        var Name = this.dataInfo.StudentName ? this.dataInfo.StudentName : "";
        let top = document.getElementById("pdfDom");
        if (top != null) {
          top.scrollIntoView();
          top = null;
        }
        var content = document.querySelector("#pdfDom");
        html2Canvas(content, {
          useCORS: true,
          scale: 1, // 提升画面质量，但是会增加文件大小
        }).then(function (canvas) {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height; //一页pdf显示html页面生成的canvas高度;
          var pageHeight = (contentWidth / 592.28) * 841.89; //未生成pdf的html页面高度
          //console.log(pageHeight);
          var leftHeight = contentHeight; //页面偏移
          var position = 0; //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = (592.28 / contentWidth) * contentHeight;

          var pageData = canvas.toDataURL("image/jpeg", 1.0);

          var pdf = new JsPDF("", "pt", "a4"); //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89) //当内容未超过pdf一页显示的范围，无需分页

          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            // 分页
            while (leftHeight > 0) {
              pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89; //避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          pdf.save(`${Name}学期报告.pdf`);

          loading.close();
        });
      }, 200);
    },
    LookActives(color, text) {
      if (color == "red") {
        this.Active = text;
        this.dialogVisible = true;
      }
    },
  },
};
</script>
<style scoped lang="less">
.table_2 .table_2_box .table .table_ans .twoList {
  font-size: 16px !important;
  color: #323333 !important;
  padding-left: 30px !important;
  line-height: 28px !important;
}
.statureHint {
  width: 678px;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #323333;
  margin: 0 auto;
  padding-bottom: 10px;
}
.statureBg {
  width: 680px;
  height: 108px;
  background: #bbd4ee;
  // box-shadow: 0px 5px 22px 2px rgba(102, 102, 102, 0.1);
  border-radius: 9px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 10px 22px;
  box-sizing: border-box;
  flex-wrap: wrap;

  .statureItem {
    width: 200px;
    height: 30px;
    display: flex;
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #323333;
    align-items: center;
    padding-top: 5px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}
.body_info {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
}
.body_info > div {
  width: 30%;
  text-align: left;
}
.body_info span {
  color: #4cbff4;
}
.tui-bgImg {
  background: url(../../assets/fengdi-f1Now.png) no-repeat;
  background-size: cover;
}
.tui-headerName {
  font-size: 58px;
  font-weight: bold;
  text-align: center;
  color: #4f6585;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 45px;
}
.tui-headerTitle {
  width: 573.75px;
  height: 147px;
  font-size: 66px;
  font-weight: bold;
  text-align: center;
  color: #4f6585;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-all-title {
  padding-top: 154px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.pingjiajieguo {
  margin-top: 0 !important;
}
.heightweight {
  margin-top: 0 !important;
}

#container {
  display: flex;
  background: #efefef;
}
#container .columns {
  height: 100%;
}
#center {
  width: 800px;
  background: #fff;
}
#left {
  flex: 1;
  height: 1000px;
}
#right {
  flex: 1;
  height: 1000px;
}
.el-table td,
.el-table th .is-leaf,
.el-table--border,
.el-table--group {
  border-color: #3f96ff;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #3f96ff;
}
.el-table th {
  border: 1px solid #3f96ff !important;
}
.flex_imgbox {
  display: flex;
  margin-top: 40px;
  margin-bottom: 40px;
  height: 200px;
  overflow: hidden;
  justify-content: space-around;
}
.imgs_src {
  width: 200px;
  height: 200px;
  overflow: hidden;
  position: relative;
  img {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    height: auto;
  }
}
.tui-download {
  position: fixed;
  right: 10%;
  bottom: 10%;
  width: 100px;
  height: 100px;
  background: #e65e5e;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  z-index: 999;
}
img {
  width: 240px;
  height: auto;
}
.icon_flexs {
  display: flex;
  justify-content: space-between;
  margin-top: 27px;
}
.icon_flex {
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon_circle {
  width: 20px;
  height: 20px;
  // background: #f44c4c;
  //   background: #3178be;
  border-radius: 50%;
  //   border: 1px solid #3178be;
  // border: 1px solid #f44c4c;
  /* margin-right: 10px; */
}
.green {
  background: rgb(52, 173, 55);
  border: 1px solid rgb(52, 173, 55);
  // background: #34ad37;
  // border: 1px solid #34ad37;
}
.blue {
  background: #3178be;
  border: 1px solid #3178be;
  // background: #eb7529;
  // border: 1px solid #eb7529;
}
.red {
  background: #eb7529;
  border: 1px solid #eb7529;
}
.icon_text {
  line-height: 35px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  padding-left: 10px;
}
.indicator {
  display: flex;
  justify-content: flex-end;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  div {
    padding-left: 30px;
    display: flex;
    align-items: center;
  }
}
.indicator div span:nth-child(1) {
  width: 17px;
  height: 17px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
}

.table_2 .table_title {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1a82fd;
  padding-bottom: 10px;
  padding-top: 10px;
  text-align: left;
}
#table0147 {
  margin-top: -20px;
}
// .table_2 .table_2_box {
//   margin-top: 40px;
// }
.table_2 .table_2_box .table {
  margin-top: 0;
}
.table_2 .table_2_box .table .table_ques {
  height: 28px;
  font-size: 24px;
  font-weight: 500;
  color: #3f96ff;
  line-height: 28px;
  background: #ffffff;
  border: 1px solid #3f96ff;
  padding: 20px 18px;
  border-bottom: none;
  border-top: none;
}

.table_2 .table_2_box .table .table_ans {
  display: flex;
  border: 1px solid #3f96ff;
  border-top: none;
  cursor: pointer;
}
.table_2 .table_2_box .table .table_ans:nth-child(1) {
  border-top: 1px solid #3f96ff;
}
.table_2 .table_2_box .table .table_ans .table_ans_list {
  font-size: 19px;
  font-weight: 500;
  color: #3f96ff;
  background: #ffffff;
  padding: 5px 15px;
  width: 90%;
  // height: 36px;
  box-sizing: border-box;
}
.table_2 .table_2_box .table .table_ans .table_ans_list:nth-child(2) {
  border-left: 1px solid #3f96ff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
}
.title_icon {
  display: flex;
  align-items: center;
  padding-top: 30px;
}
.w_icon {
  display: inline-block;
  width: 8px;
  height: 25px;
  background: #4cbff4;
  border-radius: 6px;
}
.title_icon .title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-left: 10px !important;
}
.title_desc {
  background: #c0dcff;
  border-radius: 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  padding: 30px 13px;
  margin-top: 20px;
}

.zongjie {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  //margin-top: 50px
  line-height: 50px;
}
.Capability_Report .main_content .main_tab .layui-tab-content {
  /* height: 542px; */
  margin-top: 35px;
}
.layui-tab-content {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  padding: 10px;
}
.activite {
  color: #4cbff4 !important;
}
.activite::after {
  height: 100%;
  border-bottom: 4px solid #4cbff4 !important;
  border-radius: 2px !important;
}
.Capability_Report .main_content .main_tab ul li {
  font-size: 20px;
  font-weight: 400;
  color: #999999;
  line-height: 72px;
}
.Capability_Report .main_content .main_tab .layui-tab-title {
  border: 0;
}
.Capability_Report .main_content .main_tab ul {
  height: 72px;
  padding: 0 84px;
  background: #ffffff;
  border-radius: 10px;
}
ul,
ol {
  list-style: none;
}
.Capability_Report .main_content .table_box thead th {
  height: 64px;
  font-size: 24px;
  font-weight: 500;
  color: #3f96ff;
  line-height: 64px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #3f96ff;
}
.layui-table td,
.layui-table th {
  position: relative;
  padding: 9px 15px;
  min-height: 20px;
  line-height: 20px;
  font-size: 24px;
  text-align: center;
  font-weight: 600;
}
.layui-table tr {
  transition: all 0.3s;
}
tbody tr td {
  height: 64px;
  font-size: 24px;
  font-weight: 500;
  color: #3f96ff;
  line-height: 64px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #3f96ff;
}
.layui-table td {
  background: #ffffff;
  border: 1px solid #3f96ff;
}
.layui-table {
  width: 100%;
  background-color: #fff;
  color: #666;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.layui-table,
.layui-table-view {
  margin: 10px 0;
}
.Capability_Report .main_content .table_box ul li {
  margin: 0 20px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.Capability_Report .main_content .table_box ul {
  padding-bottom: 10px;
}
.Capability_Report .main_content .table_box {
  /* padding: 79px 50px; */
  background: #ffffff;
  border-radius: 10px;
  width: 1200px;
  margin: 0 auto;
}
.Capability_Report h3 .w_icon {
  display: inline-block;
  width: 12px;
  height: 35px;
  margin-right: 16px;
  background: #4cbff4;
  border-radius: 20px;
}
.Capability_Report h3 .w_icon {
  display: inline-block;
  width: 12px;
  height: 35px;
  background: #4cbff4;
  border-radius: 6px;
}
.Capability_Report h3 {
  display: flex;
  align-items: center;
  margin: 64px 0;
  font-size: 30px;
  font-weight: bold;
  color: #666666;
  line-height: 34px;
}
.Capability_Report .main_content .layui-tab-item {
  width: 100%;
  padding: 0 154px;
}
.Capability_Report .main_content {
  /* position: absolute; */
  width: 100%;
  /* margin-top: 80px; */
  padding: 0;
  background: #6d9dd1;
}
.Capability_Report .banner .banner_tab > ul li span {
  padding: 0 20px;
  font-size: 30px;
  color: rgba(255, 255, 255, 0.5);
}
.Capability_Report .banner .banner_tab > ul .layui-this {
  font-weight: bold;
  color: #fff;
}
.Capability_Report .banner .banner_tab > ul li {
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 22px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 33px;
  cursor: pointer;
}
.layui-tab-title li {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  transition: all 0.2s;
  position: relative;
  line-height: 40px;
  min-width: 65px;
  padding: 0 15px;
  text-align: center;
  cursor: pointer;
}
.Capability_Report .banner .banner_tab > ul {
  width: 908px;
  height: 60px;
  margin: 0 auto;
  border: 2px solid rgba(255, 255, 255, 0.5);
}
.layui-tab-title {
  position: relative;
  left: 0;
  height: 40px;
  white-space: nowrap;
  font-size: 0;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  transition: all 0.2s;
}
.layui-tab {
  margin: 10px 0;
  text-align: left !important;
}
.Capability_Report .banner p {
  /* margin: 69px 0; */
  font-size: 26px;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
}
.Capability_Report .banner h1 .left {
  margin-right: 78px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}
.Capability_Report .banner h1 span {
  display: inline-block;
  width: 109px;
  height: 12px;
  border-radius: 6px;
}
.Capability_Report .banner h1 .right {
  margin-left: 78px;
  background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}
.Capability_Report .banner h1 {
  font-size: 80px;
  font-weight: bold;
  color: #ffffff;
  line-height: 91px;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.AlignItemsC {
  align-items: center;
}
.flex {
  display: flex;
}
.flexC {
  display: flex;
  flex-direction: column;
}
.JustifyContentC {
  justify-content: center;
}
.banner {
  height: 1137px;
  background: url(../../assets/newBG.png) center no-repeat;
  background-size: cover;
  position: relative;
  .tui-bottomDesc {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 43px;
    color: #fff;
    font-size: 25px;
    text-align: center;
    width: 100%;
  }
  .tui-reportHeader {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 190px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .TenanName {
      font-size: 40px;
      color: #fff;
    }
    .tui-reportTitle {
      font-size: 60px;
      color: #fff;
      padding-top: 20px;
    }
    .tui-class {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;

      span {
        width: 0.225rem;
        height: 0.225rem;
        border-radius: 50%;
        background: #ffec8e;
      }
      div {
        font-size: 0.375rem;
        color: #ffec8e;
        font-weight: 600;
        letter-spacing: 0.0625rem;
        padding: 0 0.25rem;
      }
    }
  }
}
.tui-position {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 20px;
  color: #fff;
}
.banner-position {
  position: absolute;
  top: 0.8125rem;
  left: 0;
  right: 0;
}
.banner-time {
  border-radius: 28px;
  font-size: 40px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding-top: 50px;
}
.banner-name {
  padding-top: 145px;
  font-size: 90px;
  font-family: Lantinghei SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  /* text-shadow: 0px 2px 43px rgba(11, 23, 82, 0.9); */
  letter-spacing: 30px;
}
.Capability_Report {
  width: 100%;
  min-height: 5000px;
  background: #6d9dd1;
  /* background: url(../../assets/bg-data.png) no-repeat;
  background-size: 100% 100%; */
}
.explain p {
  font-size: 18px;
  padding-bottom: 21px;
  margin: 0;
}
.GrowthMessage {
  text-indent: 2em;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  overflow: hidden;
  line-height: 20px;
  height: 160px;
}
#table0_0 {
  padding-top: 0;
}
#biaoge1 {
  padding-top: 15px;
}
#zuozheng1 {
  padding-top: 20px;
}
#biaoge2 {
  padding-top: 15px;
}
#table2_2 {
  padding-top: 15px;
}
#biaoge3 {
  padding-top: 10px;
}
#flex_imgbox3 {
  margin-top: 0;
  margin-bottom: 0;
}
#zuozheng3 {
  padding-top: 10px;
}
#biaoge5 {
  padding-top: 10px;
}
#biaoge4 {
  padding-top: 20px;
}
#zuozheng5 {
  padding-top: 10px;
}
#flex_imgbox5 {
  margin-top: 0;
}
#biaoge0 {
  padding-top: 25px;
}
.NoCover {
  position: relative;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>